import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SeletorProjetosComponent } from './seletor-projetos.component';

@NgModule({
    imports: [CommonModule],
    declarations: [SeletorProjetosComponent],
    exports: [SeletorProjetosComponent],
})
export class SeletorProjetosModule {}
